var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDetectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 64,
    viewBox: "0 0 27 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16311 1.93114C2.64885 1.72975 2.39522 1.14961 2.59661 0.63535C2.798 0.121093 3.37815 -0.132535 3.89241 0.0688555L3.16311 1.93114ZM0.793991 59.9206C0.285582 59.7048 0.0483112 59.1178 0.264036 58.6094L3.77947 50.3244C3.99519 49.816 4.58222 49.5787 5.09063 49.7944C5.59904 50.0101 5.83631 50.5972 5.62059 51.1056L2.49576 58.47L9.86023 61.5949C10.3686 61.8106 10.6059 62.3976 10.3902 62.906C10.1745 63.4144 9.58743 63.6517 9.07902 63.436L0.793991 59.9206ZM3.89241 0.0688555C14.7416 4.31758 24.6899 14.9317 26.6516 26.7288C27.6384 32.6635 26.5972 38.8823 22.6489 44.6748C18.7117 50.4513 11.9325 55.7344 1.55933 59.9271L0.80986 58.0729C10.9364 53.9799 17.3446 48.9059 20.9963 43.5484C24.637 38.207 25.5862 32.5151 24.6787 27.0569C22.8515 16.0683 13.4717 5.96813 3.16311 1.93114L3.89241 0.0688555Z",
    fill: "url(#paint0_linear_14916_21153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14916_21153",
    x1: 8.18555,
    y1: -1.48571,
    x2: 16.8321,
    y2: 23.2985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDetectArrow);
export default __webpack_public_path__ + "static/media/location-detect-arrow.3556d2a926d794d1dbe20c55fe72ab8a.svg";
export { ForwardRef as ReactComponent };